import { useCallback, useMemo } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

import './NostraStakingSunsetBanner.scss';
import Icon from '../Icon';
import Typography from '../Typography';

const NostraStakingSunsetBanner = () => {
  const navigate = useNavigate();
  const { pathname } = useLocation();

  const isVisible = useMemo(() => {
    return pathname.includes('nstSTRK');
  }, [pathname]);

  const onUnstake = useCallback(() => {
    navigate('/stake');
  }, [navigate]);

  if (!isVisible) {
    return null;
  }

  return (
    <div className="nostra__stakingSunsetBanner">
      <Icon variant="info" size={20} color="--primary-020" />
      <Typography variant="body-md" color="text-primary-darkbg">
        nstSTRK is being deprecated. Unstaking fees have been reduced to 0%. Unstake as soon as you can.
      </Typography>
      <div className="nostra__stakingSunsetBanner__action" onClick={onUnstake}>
        <Typography variant="button-sm" color="text-primary-darkbg" weight="semi-bold">
          nstSTRK
        </Typography>
        <Icon variant="arrow-right" size={16} color="--primary-020" />
      </div>
    </div>
  );
};
export default NostraStakingSunsetBanner;
